module.exports = __webpack_public_path__ + "static/img/itmee.631087d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo/itmee.png
// module id = QtMr
// module chunks = 95